import React from 'react';
import PropTypes from 'prop-types';

const Warning = ({ size }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size || 25}
    height={size || 25}
    viewBox="0 0 25 25"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#FF5D55">
        <g>
          <g>
            <g>
              <path
                d="M11.078 4.498c.087-.137.206-.252.346-.337.509-.31 1.18-.16 1.498.337l8.913 13.882c.108.168.165.363.165.561 0 .585-.487 1.059-1.087 1.059H3.088c-.204 0-.404-.056-.577-.16-.509-.31-.664-.964-.346-1.46l8.913-13.882zM12 16c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zm0-7c-.552 0-1 .448-1 1v4c0 .552.448 1 1 1s1-.448 1-1v-4c0-.552-.448-1-1-1z"
                transform="translate(-6897 -1508) translate(6073.5 724) translate(288 760) translate(536 24)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

Warning.propTypes = {
  size: PropTypes.func,
};
export default Warning;
